import { render, staticRenderFns } from "./Shipping_Cargo.vue?vue&type=template&id=57173c20&scoped=true&"
import script from "./Shipping_Cargo.vue?vue&type=script&lang=js&"
export * from "./Shipping_Cargo.vue?vue&type=script&lang=js&"
import style0 from "./Shipping_Cargo.vue?vue&type=style&index=0&id=57173c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57173c20",
  null
  
)

export default component.exports